<div
  class="wrapper flex flex-row gap-[10px] justify-between"
  [ngClass]="asArray ? 'items-start' : 'items-center'"
  [class.disabled]="disabled"
>
  <div *ngIf="label" class="label flex flex-col" [class.label--for-input]="forInput">
    <p data-at-feature-list-item-label class="flex flex-row">
      {{ label }}
      <vi-icon
        *ngIf="labelInfoTooltip"
        [matTooltip]="labelInfoTooltip"
        [size]="20"
        name="info"
        class="label-icon"
      >
      </vi-icon>
    </p>
    <p
      data-at-feature-list-item-description
      class="description"
      matTooltip="{{ description }}"
      matTooltipPosition="below"
    >
      {{ description }}
    </p>
    <!-- VIG-2996: Displaying timestamp for features-->
    <p data-at-feature-list-item-label-timestamp *ngIf="timestamp" class="timestamp">
      {{ 'GENERAL.LABEL.LAST_DATA_RECEIVED_AT' | translate }}: {{ timestamp }}
    </p>
  </div>
  <div
    class="value flex flex-row gap-[8px]"
    [class.value--for-input]="forInput"
    data-at-value
    [ngClass]="{ error: error, warning: warning, editable: editable }"
    [class.no-label]="!label"
  >
    <ng-container *ngIf="isNgContent; else noNgContentEl">
      <ng-container *ngTemplateOutlet="ngContentEl"></ng-container>
    </ng-container>
  </div>

  <div class="beta-label" *ngIf="beta">{{ beta }}</div>
</div>

<ng-template #noNgContentEl>
  <ng-container *ngIf="!asArray; else arrayValueEl">
    <div data-at-no-array-value *ngIf="!replaceValueWithElement" [matTooltip]="valueInfoTooltip">
      {{ value }} <span *ngIf="value && suffix">{{ suffix }}</span>
    </div>
    <mat-icon class="edit-icon" *ngIf="editable" (click)="edit.emit()"> edit </mat-icon>
    <ng-container *ngIf="replaceValueWithElement">
      <ng-content select="[alternativeElement]"></ng-content>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #ngContentEl>
  <ng-content></ng-content>
</ng-template>

<ng-template #arrayValueEl>
  <ng-container *ngIf="arrayHorizontalDisplay; else verticalDisplay">
    <div data-at-array-value-el-value class="flex flex-row gap-[4px]">
      {{ value }} <span *ngIf="value && suffix">{{ suffix }}</span>
    </div>
  </ng-container>
  <ng-template #verticalDisplay>
    <div data-at-vertical-display-value class="flex flex-col gap-[4px]">
      <div *ngFor="let v of value">{{ v }}</div>
    </div>
  </ng-template>
</ng-template>
